import { createContext, useState, ReactNode } from "react";
import { CommonFieldsData, generalResearch } from "../../../networking";
import { RecurringBookingFormConfirm } from "../../../services/recurringBookingInterfaces";
import {
  Enti,
  PosizioneTicket,
} from "../../AppointmentManagement/AppointmentManagement";
import { PosizioniTicketByTipologia } from "../../../services/interfaces";

export interface RecurringBookingContextType {
  entiRicerca: any[];
  posizioniTicketRicerca: any[];
  requestPosizioniTicketData: () => void;
  requestEntiData: () => void;
  selectedAppointments: any[];
  setSelectedAppointments: React.Dispatch<React.SetStateAction<any[]>>;
  confermaPianoTerapiaBody: RecurringBookingFormConfirm;
  setConfermaPianoTerapiaBody: React.Dispatch<
    React.SetStateAction<RecurringBookingFormConfirm>
  >;
  posizioniTicketByTipologia: PosizioniTicketByTipologia[];
  setPosizioniTicketByTipologia: React.Dispatch<
    React.SetStateAction<PosizioniTicketByTipologia[]>
  >;
  importoTotale: string;
  setImportoTotale: React.Dispatch<React.SetStateAction<string>>;
  importoListino: any;
  setImportoListino: React.Dispatch<React.SetStateAction<any>>;
  uniqueAppointmentIds: string[];
  setUniqueAppointmentIds: React.Dispatch<React.SetStateAction<string[]>>;
  uniqueAppointmentItems: string[];
  setUniqueAppointmentItems: React.Dispatch<React.SetStateAction<string[]>>;
}

const RecurringBookingContext = createContext<
  RecurringBookingContextType | undefined
>(undefined);

const RecurringBookingContextWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [entiRicerca, setEntiRicerca] = useState<any>(null);
  const [posizioniTicketRicerca, setPosizioniTicketRicerca] =
    useState<any>(null);
  const [selectedAppointments, setSelectedAppointments] = useState<any>([]);
  const [confermaPianoTerapiaBody, setConfermaPianoTerapiaBody] =
    useState<RecurringBookingFormConfirm>({});
  const [posizioniTicketByTipologia, setPosizioniTicketByTipologia] = useState<
    PosizioniTicketByTipologia[]
  >([]);
  const [importoTotale, setImportoTotale] = useState<string>("0,00 €");
  const [importoListino, setImportoListino] = useState<any>("0,00 €");
  const [uniqueAppointmentIds, setUniqueAppointmentIds] = useState<string[]>(
    []
  );
  const [uniqueAppointmentItems, setUniqueAppointmentItems] = useState<
    string[]
  >([]);

  let entiController: AbortController | null = null;
  let posizioniController: AbortController | null = null;

  const requestEntiData = async () => {
    const objectJsonRequest: CommonFieldsData = {
      tabella: "ENTI",
      codice: "",
      filtro: "",
      applicazione: "",
      attivi: "1",
    };

    if (entiController) {
      entiController.abort();
    }
    entiController = new AbortController();

    try {
      const objectJsonResponse = await generalResearch(
        objectJsonRequest,
        entiController.signal
      );
      const dataEnti = objectJsonResponse.data.dati.map(
        (e: Enti, index: number) => ({
          ...e,
          indice: index,
        })
      );

      const dataEntiToSort: Enti[] = dataEnti;

      const sortedData = dataEntiToSort.sort((a, b) => {
        if (a["ragione sociale"] > b["ragione sociale"]) {
          return 1;
        }
        if (b["ragione sociale"] > a["ragione sociale"]) {
          return -1;
        }
        return 0;
      });
      console.log("ENTI", sortedData);
      setEntiRicerca(sortedData);
    } catch (error) {
      console.error("Errore nella fetch di ricerca degli enti", error);
      return [];
    }
  };

  const requestPosizioniTicketData = async () => {
    const objectJsonRequest: CommonFieldsData = {
      tabella: "Postic",
      codice: "",
      filtro: "",
      applicazione: "",
      attivi: "1",
      "tipo calcolo": "",
    };

    if (posizioniController) {
      posizioniController.abort();
    }
    posizioniController = new AbortController();

    try {
      const objectJsonResponse = await generalResearch(
        objectJsonRequest,
        posizioniController.signal
      );

      const dataPosizioneTickets = objectJsonResponse.data.dati.map(
        (e: PosizioneTicket, index: number) => {
          return {
            ...e,
            indice: index,
          };
        }
      );

      const dataPosizioneTicketsToSort: PosizioneTicket[] =
        dataPosizioneTickets;

      const sortedData = dataPosizioneTicketsToSort.sort((a, b) => {
        if (a.descrizione > b.descrizione) {
          return 1;
        }
        if (b.descrizione > a.descrizione) {
          return -1;
        }
        return 0;
      });
      console.log("TICKET", sortedData);
      setPosizioniTicketRicerca(sortedData);
    } catch (error) {
      console.error("Errore nella fetch di ricerca delle posizioni ticket");
      return [];
    }
  };

  const prop = {
    entiRicerca,
    posizioniTicketRicerca,
    requestEntiData,
    requestPosizioniTicketData,
    selectedAppointments,
    setSelectedAppointments,
    confermaPianoTerapiaBody,
    setConfermaPianoTerapiaBody,
    posizioniTicketByTipologia,
    setPosizioniTicketByTipologia,
    importoTotale,
    setImportoTotale,
    importoListino,
    setImportoListino,
    uniqueAppointmentIds,
    setUniqueAppointmentIds,
    uniqueAppointmentItems,
    setUniqueAppointmentItems,
  };

  return (
    <RecurringBookingContext.Provider value={prop}>
      {children}
    </RecurringBookingContext.Provider>
  );
};

export { RecurringBookingContextWrapper, RecurringBookingContext };
